import { render, staticRenderFns } from "./ExtAstaSxPreview.vue?vue&type=template&id=3c4eff5a"
import script from "./ExtAstaSxPreview.vue?vue&type=script&lang=js"
export * from "./ExtAstaSxPreview.vue?vue&type=script&lang=js"
import style0 from "./ExtAstaSxPreview.vue?vue&type=style&index=0&id=3c4eff5a&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\ldemenego\\REPOS\\VUEJS\\configuratore-demenego-v2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c4eff5a')) {
      api.createRecord('3c4eff5a', component.options)
    } else {
      api.reload('3c4eff5a', component.options)
    }
    module.hot.accept("./ExtAstaSxPreview.vue?vue&type=template&id=3c4eff5a", function () {
      api.rerender('3c4eff5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ExtAstaSxPreview.vue"
export default component.exports